import Vue from 'vue'
import Vuex from 'vuex'

import { ClientShow, ClientSelfLogin } from '@/api/clientApi.js'
import {
  screenType, winTypeMap, winTypeSizeHigh,
  winTypeSizeLow, projectType
} from '@/common/const.js'

import operational from '@/store/operational.js'
import home from '@/store/home.js'
import activity from '@/store/activity.js'
import tipsDialog from '@/store/tipsDialog.js'
import unshow from '@/store/unshow.js'
import report from '@/store/report'
import abTest from '@/store/abTest'
import channel from '@/store/channel'
import buyDialog from '@/store/buyDialog'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    projectType: projectType.ppt,
    activeIndex: null, // 存储侧边一级导航， 如果包含我的页面，要注意，我的页面脱离该范围
    elementIndex: [2], // 元素的下标，布局不一样，接口获取长度也不一样
    winTypeDefault: winTypeMap.normal,
    winType: winTypeMap.normal,
    loadingMask: false, // 只有mask
    loading: false,
    isDownloading: false,
    userInfo: {},
    screenType: screenType.high,
    dialogPayAbTestType: null,
    // 毒霸vip目前不和办公账户关联，只要用户在当前环境的毒霸里面登录了毒霸vip就是毒霸vip
    isDubaVip: false,
    // 是否是前端调起毒霸登录窗，用于拦截用户主动从毒霸客户端调起登录窗的支付窗唤起
    isShowDubaLogin: false,
    isShowLottery: false,
    isDialogShowing: false, // 弹窗展示中，用于处理用户设置了插件不弹出后，绑定等弹窗弹出被最小化遮挡的问题
  },

  mutations: {
    vuexChangeActiveIndex (state, index) {
      state.activeIndex = index
    },

    vuexSetElementIndex (state, arr) {
      state.elementIndex = arr
    },

    vuexChangeLoading (state, flag) {
      state.loading = flag
    },

    vuexChangeLoadingMask (state, flag) {
      state.loadingMask = flag
    },

    vuexSetUserInfo (state, userInfo) {
      state.userInfo = userInfo
    },

    vuexChangeDownloadStatus (state, flag) {
      state.isDownloading = flag
    },

    vuexChangScreenType (state, type) {
      state.screenType = type
    },

    vuexChangeWinType (state, type) {
      state.winType = type
    },

    vuexChangeWinTypeDefault (state, type) {
      state.winTypeDefault = type
    },

    vuexChangePayAbTestType (state, dialogPayAbTestType) {
      state.dialogPayAbTestType = dialogPayAbTestType
    },

    vuexChangeProjectType (state, projectType) {
      state.projectType = projectType
    },

    vuexChangeIsDubaVip (state, isDubaVip) {
      state.isDubaVip = isDubaVip
    },
    vuexChangeIsShowDubaLogin (state, isShowDubaLogin) {
      state.isShowDubaLogin = isShowDubaLogin
    },
    vuexChangeIsShowLottery (state, isShowLottery) {
      state.isShowLottery = isShowLottery
    },
    vuexChangeIsDialogShowing (state, isDialogShowing) {
      state.isDialogShowing = isDialogShowing
    }
  },

  actions: {
    vuexChangeWinType ({ state, commit }, type) {
      commit('vuexChangeWinType', type)
      if (state.isDialogShowing) {
        type = winTypeMap.normal
      }
      if (state.screenType === screenType.high) {
        ClientShow(winTypeSizeHigh[type])
      } else {
        ClientShow(winTypeSizeLow[type])
      }
    },
    showLoginByChannel () {
      ClientSelfLogin()
    }
  },
  getters: {
    isLoginedIn (state) {
      return !!state.userInfo.token
    },

    isVip (state) {
      return state.userInfo.isVip
    },

    // 特殊处理：判断终身会员，目前会员没有字段表示终身会员，目前使用有效期来判断
    // 依据可牛最新协议，终身会员并非真正终身，有效期为27年左右，由于无法获取到会员购买的日期，最早一批可牛用户是2021购买会员
    // 直接使用2040年作为判断年限
    isVipForever (state) {
      const privliegeEndTime = state.userInfo.privliegeEndTime
      if (privliegeEndTime) {
        const [strYear] = privliegeEndTime.split('-')
        const yearForever = 2040
        if (Number(strYear) >= yearForever) {
          return true
        }
      }
      return false
    },

    isMini (state) { // 当前的winType
      return state.winType === winTypeMap.mini
    },

    isMiniDefault (state) {
      return state.winTypeDefault === winTypeMap.mini
    },

    isLowScreen (state) {
      return state.screenType === screenType.low
    },

    classNameScreenType (state) {
      return `screen_type_${state.screenType}`
    }
  },

  modules: { operational, home, activity, tipsDialog, unshow, report, abTest, channel, buyDialog }
})
